module.exports = __webpack_public_path__ + "img/tag_irv1.0f8127ef.svg";